(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daniels-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('daniels-review-carousel')) {
    class DanielsReviewCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;

        this.track = this.querySelector('[data-review-track]');
        this.previousButton = this.querySelector('[data-review-prev]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.controls = this.querySelector('[data-review-controls]');
        this.dots = this.querySelector('[data-review-dots]');
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));

        if (!this.track || !this.cards.length) return;

        this.dataset.initialized = 'true';
        this.currentPage = 0;
        this.pageCount = 1;
        this.scrollFrame = null;

        this.onPrevious = () => this.goToPage(this.currentPage - 1);
        this.onNext = () => this.goToPage(this.currentPage + 1);
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.updateCurrentPage();
          });
        };
        this.onKeydown = (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goToPage(this.currentPage - 1);
          }

          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goToPage(this.currentPage + 1);
          }
        };
        this.onBlockSelect = (event) => {
          const card = event.target.closest('[data-review-card]');
          if (!card || !this.contains(card)) return;
          card.scrollIntoView({ behavior: this.prefersReducedMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.refresh());
          this.resizeObserver.observe(this.track);
        } else {
          this.onResize = () => this.refresh();
          window.addEventListener('resize', this.onResize);
        }

        requestAnimationFrame(() => this.refresh());
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      measurements() {
        const firstCard = this.cards[0];
        const trackStyles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
        const cardWidth = firstCard.getBoundingClientRect().width;

        if (!cardWidth || !this.track.clientWidth) {
          return { step: 1, visibleCards: 1 };
        }

        const step = cardWidth + gap;
        const visibleCards = Math.max(1, Math.round((this.track.clientWidth + gap) / step));

        return { step, visibleCards };
      }

      refresh() {
        const { visibleCards } = this.measurements();
        const nextPageCount = Math.max(1, Math.ceil(this.cards.length / visibleCards));

        if (nextPageCount !== this.pageCount || !this.dots?.children.length) {
          this.pageCount = nextPageCount;
          this.renderDots();
        }

        if (this.controls) this.controls.hidden = this.pageCount <= 1;
        this.updateCurrentPage();
      }

      renderDots() {
        if (!this.dots) return;

        this.dots.replaceChildren();

        for (let index = 0; index < this.pageCount; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'daniels-reviews__dot';
          dot.setAttribute('aria-label', `Visa omdömessida ${index + 1} av ${this.pageCount}`);
          dot.addEventListener('click', () => this.goToPage(index));
          this.dots.append(dot);
        }
      }

      updateCurrentPage() {
        const { step, visibleCards } = this.measurements();
        const pageWidth = step * visibleCards;
        const nextPage = Math.min(this.pageCount - 1, Math.max(0, Math.round(this.track.scrollLeft / pageWidth)));

        this.currentPage = nextPage;
        if (this.previousButton) this.previousButton.disabled = nextPage === 0;
        if (this.nextButton) this.nextButton.disabled = nextPage >= this.pageCount - 1;

        Array.from(this.dots?.children || []).forEach((dot, index) => {
          dot.setAttribute('aria-current', index === nextPage ? 'true' : 'false');
        });
      }

      goToPage(page) {
        const targetPage = Math.min(this.pageCount - 1, Math.max(0, page));
        const { step, visibleCards } = this.measurements();

        this.track.scrollTo({
          left: targetPage * step * visibleCards,
          behavior: this.prefersReducedMotion() ? 'auto' : 'smooth'
        });
      }
    }

    customElements.define('daniels-review-carousel', DanielsReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
